
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { DateInput, Align } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { ControlledField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Date Input`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { DateInput } from '@drawbotics/react-drylus';
`}</code></pre>
<p>{`Note: any additional props are passed to the input component.`}</p>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<div style={{ maxWidth: 300 }}>
  <ControlledField initialValue="" component={
    <DateInput value="" align={Align.RIGHT} placeholder="Pick a date..." />
  } />
</div>`} component={DateInput} mdxType="Playground">
  <div style={{
        maxWidth: 300
      }}>
    <ControlledField initialValue="" component={<DateInput value="" align={Align.RIGHT} placeholder="Pick a date..." mdxType="DateInput" />} mdxType="ControlledField" />
  </div>
</Playground>
<p>{`If you need to limit the range of dates you can use `}<inlineCode parentName="p">{`maxDate`}</inlineCode>{` and/or `}<inlineCode parentName="p">{`minDate`}</inlineCode>{` (see the `}<a parentName="p" {...{
        "href": "https://github.com/wojtekmaj/react-calendar#readme"
      }}>{`react-calendar`}</a>{` documentation for the full list of options).`}</p>
<Playground __position={1} __code={`<div style={{ maxWidth: 300 }}>
  <ControlledField initialValue="" component={
    <DateInput
      value=""
      placeholder="Pick a date..."
      maxDate={{ year: 2010, month: 4, day: 10 }}
      activeStartDate={{ year: 2010, month: 4, day: 10 }}
      minDate={{ year: 2010, month: 4, day: 1 }}
      onChange={x=>x} />
  } />
</div>`} mdxType="Playground">
  <div style={{
        maxWidth: 300
      }}>
    <ControlledField initialValue="" component={<DateInput value="" placeholder="Pick a date..." maxDate={{
          year: 2010,
          month: 4,
          day: 10
        }} activeStartDate={{
          year: 2010,
          month: 4,
          day: 10
        }} minDate={{
          year: 2010,
          month: 4,
          day: 1
        }} onChange={x => x} mdxType="DateInput" />} mdxType="ControlledField" />
  </div>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;